import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { GENERIC_ELEMENT_ID } from '@dealstack/shared/tests/testElementIds';
import { TableToolbarButtonProps } from '@dealstack/frontend/shared/components/Table/MantineTable/table-utils';
import { RecordAny } from '@dealstack/shared/lib/common/common';
import styled from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid transparent;
	border-left-color: ${({ theme }) => theme.v3.colors.gray[2]};
	height: 3rem;
	width: 3rem;
	color: ${({ theme }) => theme.v3.colors.dark[0]};
	padding: 0.75rem;
	border-radius: 0;
	cursor: pointer;

	&.active,
	&:active {
		background-color: ${({ theme }) => theme.v3.colors.blue[0]};
		border-color: ${({ theme }) => theme.v3.colors.blue[2]};
	}
`;

export const ToggleFullScreenButton = <TData extends RecordAny>({
	table,
	className,
	iconSize = 'xl',
}: TableToolbarButtonProps<TData>) => {
	const tableMeta = table.options.meta as Record<string, unknown>;
	const isFullScreen = (tableMeta?.isFullScreen as boolean) ?? false;
	const setIsFullScreen = tableMeta?.setIsFullScreen as (v: boolean) => void;

	const icon = isFullScreen ? (
		<Icon variant="collapse-diagonally" size={iconSize} />
	) : (
		<Icon variant="expand-diagonally" size={iconSize} />
	);

	const handleToggleFullScreen = () => {
		setIsFullScreen?.(!isFullScreen);
	};

	return (
		<StyledContainer
			onClick={handleToggleFullScreen}
			className={className}
			data-testid={GENERIC_ELEMENT_ID.MANTINE_TABLE_FULL_SCREEN_TOGGLE}
		>
			{icon}
		</StyledContainer>
	);
};
